import React from 'react';
import {
  Box,
  Typography,
  Button,
  Alert,
  AlertTitle,
} from '@mui/material';
import {
  AutoAwesome as SparklesIcon,
  EmojiEvents as CrownIcon,
} from '@mui/icons-material';
import { useTheme } from '../../contexts/ThemeContext';
import { SubscriptionPlan } from '../../types/subscription';

interface UpgradePromptProps {
  feature: string;
  currentPlan: SubscriptionPlan;
  onUpgrade?: () => void;
  className?: string;
}

export const UpgradePrompt: React.FC<UpgradePromptProps> = ({
  feature,
  currentPlan,
  onUpgrade,
  className
}) => {
  const { theme } = useTheme();

  const getRecommendedPlan = () => {
    if (currentPlan === 'free') return 'premium';
    return 'pro';
  };

  const getPlanIcon = (plan: SubscriptionPlan) => {
    if (plan === 'premium') return <SparklesIcon sx={{ fontSize: '1rem' }} />;
    return <CrownIcon sx={{ fontSize: '1rem' }} />;
  };

  const getPlanColor = (plan: SubscriptionPlan) => {
    if (plan === 'premium') return theme.colors.secondary;
    return '#F59E0B';
  };

  const recommendedPlan = getRecommendedPlan();

  return (
    <Alert
      severity="info"
      className={className}
      sx={{
        backgroundColor: `${getPlanColor(recommendedPlan)}15`,
        border: `1px solid ${getPlanColor(recommendedPlan)}30`,
        borderRadius: theme.radii.medium,
        marginBottom: 2,
        '& .MuiAlert-icon': {
          color: getPlanColor(recommendedPlan),
        },
      }}
      icon={getPlanIcon(recommendedPlan)}
    >
      <AlertTitle sx={{ fontWeight: 'bold', color: theme.colors.text.primary }}>
        Limite quase atingido
      </AlertTitle>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 2 }}>
        <Typography variant="body2" sx={{ color: theme.colors.text.primary, flex: 1 }}>
          Você está próximo do limite de {feature}. Faça upgrade para continuar aproveitando todos os recursos.
        </Typography>
        {onUpgrade && (
          <Button
            size="small"
            variant="contained"
            onClick={onUpgrade}
            sx={{
              backgroundColor: getPlanColor(recommendedPlan),
              color: 'white',
              borderRadius: theme.radii.small,
              fontWeight: 'bold',
              fontSize: '0.75rem',
              minWidth: 'auto',
              px: 2,
              '&:hover': {
                backgroundColor: getPlanColor(recommendedPlan),
                opacity: 0.8,
              },
            }}
          >
            Upgrade
          </Button>
        )}
      </Box>
    </Alert>
  );
};